import { Link } from 'react-router-dom'
import Modals from 'singletons/Modals'

type ScheduledProps = {
  shouldDisableVisitPage: boolean
  pendingVisitId: string
  isSuccess: boolean
}
const Scheduled = ({ pendingVisitId, shouldDisableVisitPage, isSuccess }: ScheduledProps) => {
  return (
    <div className="flex justify-end gap-4">
      {shouldDisableVisitPage ? (
        <button type="button" className="btn-small btn-primary-outlined" onClick={() => Modals.open('rescheduleVisit')}>
          Reschedule
        </button>
      ) : null}
      <Link to={`/visits/${pendingVisitId}`} className="btn-small btn-primary-outlined">
        Go to {isSuccess ? 'session' : 'visit'}
      </Link>
    </div>
  )
}

export default Scheduled
